import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {NB_AUTH_OPTIONS, NbAuthService, NbRegisterComponent} from '@nebular/auth';
import {ConstantsService} from '../../@core/utils/constants.service';
import {Router} from '@angular/router';

@Component({
	selector: 'ngx-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss'],
})
export class RegisterComponent extends NbRegisterComponent {

	constructor(service: NbAuthService, @Inject(NB_AUTH_OPTIONS) options: {}, cd: ChangeDetectorRef, router: Router,
				public constantsService: ConstantsService ) {
		super(service, options, cd, router);
	}

    updateLogoURL($event) {
		$event.target.src = this.constantsService.roadcastURL;
    }
}
